// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flex-50[data-v-f1abe27c]{flex:1 1 0}", "",{"version":3,"sources":["webpack://src/components/pages/CountdownTimerForm.vue"],"names":[],"mappings":"AAAA,0BAA0B,UAAU","sourcesContent":[".flex-50[data-v-f1abe27c]{flex:1 1 0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
